<div
  class="rounded-lg border p-3 shadow-sm sm:p-5"
  [class]="{
    'border-green-200 bg-green-50': producto().estado === EComandaProductoEstado.LISTO,
    'border-blue-200 bg-blue-50': producto().estado === EComandaProductoEstado.EN_PREPARACION,
    'border-yellow-200 bg-yellow-50': producto().estado === EComandaProductoEstado.PENDIENTE,
    'border-slate-200 bg-slate-50 opacity-70':
      producto().estado === EComandaProductoEstado.ENTREGADO,
    'border-red-200 bg-red-50 opacity-75': producto().estado === EComandaProductoEstado.CANCELADO,
  }"
>
  <div class="mb-3 flex flex-wrap items-start justify-between gap-3">
    <div class="min-w-0 flex-1">
      <h4 class="wrap-break-words text-sm font-semibold leading-snug text-slate-900 sm:text-base">
        {{ producto().nombre_producto }}
      </h4>
      <p class="text-xs text-slate-600 sm:text-sm">
        Cantidad: {{ producto().cantidad }} |
        {{ producto().precio_unitario | currency: 'PEN' : 'S/. ' }} c/u
      </p>
      @if (producto().nota) {
        <div class="mt-2 rounded-r border-l-4 border-amber-400 bg-amber-50 p-2">
          <div class="flex items-start gap-2">
            <i class="bi bi-sticky text-amber-600 text-sm mt-0.5"></i>
            <div class="flex-1">
              <p class="text-xs font-semibold text-amber-800 uppercase">Nota</p>
              <p class="wrap-break-words text-sm text-amber-900">{{ producto().nota }}</p>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="flex w-full flex-wrap items-center justify-start gap-2 sm:w-auto sm:justify-end">
      <span
        class="whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold shadow-sm"
        [class]="{
          'bg-green-100 text-green-800': producto().estado === EComandaProductoEstado.LISTO,
          'bg-blue-100 text-blue-800': producto().estado === EComandaProductoEstado.EN_PREPARACION,
          'bg-yellow-100 text-yellow-800': producto().estado === EComandaProductoEstado.PENDIENTE,
          'bg-slate-100 text-slate-800': producto().estado === EComandaProductoEstado.ENTREGADO,
          'bg-red-100 text-red-800': producto().estado === EComandaProductoEstado.CANCELADO,
        }"
        >{{ estadoProducto() }}</span
      >
    </div>
  </div>

  <div class="mb-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
    <div class="flex items-center gap-2 text-xs text-slate-500 font-medium">
      <span
        class="w-2 h-2 rounded-full"
        [class]="{
          'bg-yellow-400': producto().estado === EComandaProductoEstado.PENDIENTE,
          'bg-blue-500': producto().estado === EComandaProductoEstado.EN_PREPARACION,
          'bg-green-500': producto().estado === EComandaProductoEstado.LISTO,
          'bg-slate-500': producto().estado === EComandaProductoEstado.ENTREGADO,
          'bg-red-500': producto().estado === EComandaProductoEstado.CANCELADO,
        }"
      ></span>
      <span class="uppercase tracking-wide">Estado</span>
    </div>
    <button
      type="button"
      class="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-linear-to-r from-blue-600 via-indigo-600 to-purple-600 px-4 py-2 text-sm font-semibold text-white shadow-md transition hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto"
      [disabled]="!puedeAvanzarEstado()"
      (click)="avanzarEstadoProducto()"
    >
      <span>{{ botonAvanzarEstadoTexto() }}</span>
      <i class="bi bi-caret-right-fill text-xs"></i>
    </button>
  </div>

  <div class="space-y-2">
    <div class="grid grid-cols-4 text-[10px] font-semibold text-slate-500 sm:text-[11px]">
      <span class="text-left">Pend.</span>
      <span class="text-center">Prep.</span>
      <span class="text-center">Listo</span>
      <span class="text-right">Entregado</span>
    </div>
    <div class="h-2 overflow-hidden rounded-full bg-slate-200">
      <div
        class="h-full rounded-full bg-linear-to-r from-amber-400 via-blue-500 to-emerald-500 transition-all duration-300"
        [style.width.%]="estadoProgreso()"
      ></div>
    </div>
  </div>

  <div class="mt-4 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
    <button
      class="order-2 rounded-lg px-2 py-1.5 text-sm font-medium text-red-600 transition hover:bg-red-50 hover:text-red-900 sm:order-1"
      type="button"
      (click)="eliminarProducto()"
    >
      <i class="bi bi-trash3 mr-1" aria-hidden="true"></i>
      Eliminar
    </button>
    <span class="order-1 whitespace-nowrap text-sm font-semibold text-slate-700 sm:order-2">
      {{ producto().cantidad * producto().precio_unitario | currency: 'PEN' : 'S/. ' }}
    </span>
  </div>
</div>
